var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.pageNotFound},[_vm._v(" 404 Not Found ")])
}
var staticRenderFns = []

export { render, staticRenderFns }